import Service from '../abstract/service'

export default class Equipe extends Service {
  constructor () {
    super()
    this._equipeRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    )
  }

  async selectAll (empresas, empresasArray) {
    try {
      this._loading.setLoading(true, 'Carregando Equipes')
      let equipes = new Array()
      for (let empresa of empresas) {
        const response = await this._equipeRef
          .doc(empresa)
          .collection('Equipes')
          .get()

        const emp = empresasArray.find(element => element.cnpj === empresa)
        for (let doc of response.docs) {
          let equipe = doc.data()

          equipes.push({
            id: doc.id,
            cnpj: emp.cnpj,
            nomeEmpresa: emp.nome,
            ...equipe
          })
        }
      }

      return Promise.resolve(equipes)
    } catch (error) {
      return Promise.resolve(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  async selectEquipeAll (empresas) {
    try {
      this._loading.setLoading(true, 'Carregando Equipes')
      let equipes = new Array()

      const response = await this._equipeRef
        .doc(empresas)
        .collection('Equipes')
        .get()

      for (let doc of response.docs) {
        let equipe = doc.data()

        equipes.push({
          id: doc.id,
          ...equipe
        })
      }

      return Promise.resolve(equipes)
    } catch (error) {
      return Promise.resolve(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  async updateEquipe (
    equipe,
    cnpj,
    codigoEquipe,
    colaboradoresNovos = [],
    colaboradoresAntigos = []
  ) {
    try {
      this._loading.setLoading(true, 'Atualizando Equipe')
      await this._equipeRef
        .doc(cnpj)
        .collection('Equipes')
        .doc(codigoEquipe)
        .update({
          colaboradores: colaboradoresNovos
        })
      await this.insertHistorico(
        codigoEquipe,
        cnpj,
        equipe,
        colaboradoresAntigos,
        colaboradoresNovos,
        'Trocar de colaboradores'
      )
      return Promise.resolve(true)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  async selectEquipeCodigo (cnpj, codigoEquipe) {
    try {
      let obj = null
      const response = await this._equipeRef
        .doc(cnpj)
        .collection('Equipes')
        .where('codigoEquipe', '==', codigoEquipe)
        .get()

      for (let item of response.docs) obj = item.data()

      return Promise.resolve(obj)
    } catch (error) {
      return Promise.reject(error)
    }
  }
  async insertEquipe (cnpj, equipe) {
    try {
      await this._equipeRef
        .doc(cnpj)
        .collection('Equipes')
        .doc(equipe.codigoEquipe)
        .set({
          nome: equipe.nome,
          supervisor: equipe.supervisor[0].cpf,
          codigoEquipe: equipe.codigoEquipe,
          dataCriacao: new Date(),
          colaboradores: equipe.colaboradores,
          ativo: equipe.ativo
        })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
  async updataNomeEquipe (codigoEquipe, cnpj, equipe) {
    try {
      await this._equipeRef
        .doc(cnpj)
        .collection('Equipes')
        .doc(codigoEquipe)
        .update({
          nome: equipe.nome,
          ativo: equipe.ativo
        })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
  async insertHistorico (
    id,
    cnpj,
    equipe,
    colaboradoresAntigos = [],
    colaboradoresNovos = [],
    title
  ) {
    try {
      const user = this._store.getters['auth/getUser']
      const response2 = await this._equipeRef
        .doc(cnpj)
        .collection('Equipes')
        .doc(id)
        .collection('HistoricoEquipe')
        .doc()
        .set({
          comentario: title,
          dataCriacao: new Date(),
          ativo: equipe.ativo,
          nomeEquipe: equipe.nome,
          colaboradoresNovos: colaboradoresNovos,
          colaboradoresAntigos: colaboradoresAntigos,
          supervisor: equipe.supervisor,
          usuario: user.id,
          usuarioNome: user.nome
        })

      return Promise.resolve(response2)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
